const REFRESH_INTERVAL = 1000 * 60 * 30; // 30 minutes
const TOKEN_KEY = "basiq-token";
const STATE_KEY = "basiq-state";
const TOKEN_EXPIRY_KEY = "basiq-token-expires";
const BASIQ_USER_KEY = "basiq-userid";

function tokenKey(userId: string) {
  return `${TOKEN_KEY}-${userId}`;
}

function stateKey(userId: string) {
  return `${STATE_KEY}-${userId}`;
}

export function getCachedBasiqCredentials() {
  const userId = getBasiqUserIdFromLocalStorage();
  const token = userId ? getClientTokenFromLocalStorage(userId) : null;
  const state = userId ? getClientStateFromLocalStorage(userId) : null;
  const expiresDate = getClientTokenExpiresDate() || 0;

  return { userId, token, expiresDate, state };
}

export function updateCachedBasiqCredentials(token: string, userId: string, state: string) {
  setClientUserIdInLocalStorage(userId);
  setClientTokenInLocalStorage(userId, token);
  setClientStateInLocalStorage(userId, state);

  const expiryDate = Date.now() + REFRESH_INTERVAL;
  setClientTokenExpiresDate(expiryDate);
}

export function clearCachedBasiqCredentials(userId: string) {
  localStorage.removeItem(BASIQ_USER_KEY);
  localStorage.removeItem(TOKEN_EXPIRY_KEY);
  localStorage.removeItem(tokenKey(userId));
  localStorage.removeItem(stateKey(userId));
}

function getBasiqUserIdFromLocalStorage() {
  return localStorage.getItem(BASIQ_USER_KEY);
}

function setClientUserIdInLocalStorage(userId: string) {
  localStorage.setItem(BASIQ_USER_KEY, userId);
}

function getClientTokenFromLocalStorage(userId: string) {
  return localStorage.getItem(tokenKey(userId));
}

function setClientTokenInLocalStorage(userId: string, token: string) {
  localStorage.setItem(tokenKey(userId), token);
}

function getClientStateFromLocalStorage(userId: string) {
  return localStorage.getItem(stateKey(userId));
}

function setClientStateInLocalStorage(userId: string, state: string) {
  localStorage.setItem(stateKey(userId), state);
}

function getClientTokenExpiresDate() {
  return localStorage.getItem(TOKEN_EXPIRY_KEY);
}

function setClientTokenExpiresDate(timestamp) {
  localStorage.setItem(TOKEN_EXPIRY_KEY, timestamp);
}
